import { Link } from 'react-router-dom';

import styled from 'styled-components';

import { PAGES } from 'constants/pages';

import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';

import { MealPlanDefinitionsList } from './components/MealPlanDefinitionsList';
import { TotadminPermission } from 'data/__generated__';

export const MealPlanDefinitions = () => {
    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.mealPlanDefinitions} />
                </HeaderTitle>
                <Link to={PAGES.mealPlanDefinitionCreate.url}>
                    <TotemPrimaryButton
                        data-test="create-meal-plan-definition-button"
                        requiredPermissions={[TotadminPermission.MealPlanDefinitionsManage]}
                    >
                        Créer une formule
                    </TotemPrimaryButton>
                </Link>
            </Header>
            <Content>
                <ListContainer>
                    <MealPlanDefinitionsList />
                </ListContainer>
            </Content>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;

const ListContainer = styled.div`
    flex: 1;
    overflow: hidden;
`;
